import React from 'react'

import { Box, Color, DisplayPosition, withCitrusTheme } from '@gousto-internal/citrus-react'

import type { StandardRecipeItem } from '@library/api-menu-experience'

import { BasketButton } from '../BasketButton'
import { CustomisationLabel } from './CustomisationLabel'
import { RecipeSurcharge } from './RecipeSurcharge'
import { SubtitleTagRow } from './SubtitleTagRow'
import { RecipeTitle } from './RecipeTitle'
import { SoldOutOverlay } from '../SoldOutOverlay'
import type { RecipeTileActionProps } from '../RecipeTile.types'

type RecipeTileBodyProps = {
  recipe: StandardRecipeItem
  isOutOfStock: boolean
  isCustomisationOpen?: boolean
  onCustomiseClick?: () => void
} & RecipeTileActionProps

const RecipeTileBodyWrapper = withCitrusTheme(Box, () => ({
  boxSizing: 'border-box',
  paddingTop: '26px',
}))

const MetadataContainer = withCitrusTheme(Box, (theme) => ({
  paddingTop: `${theme.spacing(3)}px`,
}))

export const RecipeTileBody = ({
  recipe,
  isOutOfStock,
  isInBasket,
  canAddRecipes,
  reachedLimit,
  onAddClick,
  onRemoveClick,
  onBlockedAddAttempt,
  isCustomisationOpen = false,
  onCustomiseClick,
}: RecipeTileBodyProps) => {
  return (
    <RecipeTileBodyWrapper
      bg={Color.White}
      flexBasis="0%"
      flexGrow={1}
      flexShrink={1}
      minHeight="100px"
      paddingBottom={4}
      paddingH={4}
      position={DisplayPosition.Relative}
    >
      <BasketButton
        recipe={recipe}
        isInBasket={isInBasket}
        isOutOfStock={isOutOfStock}
        canAddRecipes={canAddRecipes}
        reachedLimit={reachedLimit}
        onAddClick={onAddClick}
        onRemoveClick={onRemoveClick}
        onBlockedAddAttempt={onBlockedAddAttempt}
      />
      <SoldOutOverlay isOutOfStock={isOutOfStock} />
      <RecipeTitle title={recipe.title} />
      <MetadataContainer>
        <SubtitleTagRow recipe={recipe} />
      </MetadataContainer>
      <Box bottom="0.5rem" position={DisplayPosition.Absolute} right="1rem">
        <CustomisationLabel
          recipe={recipe}
          isOpen={isCustomisationOpen}
          onClick={onCustomiseClick}
        />
      </Box>
      <RecipeSurcharge recipe={recipe} isOutOfStock={isOutOfStock} />
    </RecipeTileBodyWrapper>
  )
}
